import * as React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
const brandSlots = [{
  id: "hitachi",
  name: "Hitachi",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_hitachi.png",
  tagline: "Excelencia Japonesa",
  description: "Líder mundial en excavadoras hidráulicas y maquinaria de minería de alto rendimiento.",
  backgroundImage: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/HITACHI-1.jpg",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/HITACHI-1.jpg)]"
}, {
  id: "fiat",
  name: "KOBELCO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_fiat.png",
  tagline: "Potencia Italiana",
  description: "Componentes robustos y fiables para maquinaria agrícola y de construcción pesada.",
  backgroundImage: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/KOBELCO-1.jpg",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/KOBELCO-1.jpg)]",
  idClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center h-48 !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/KOBELCO-1.jpg)]"
}, {
  id: "new-holland",
  name: "New Holland",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_new_holland.png",
  tagline: "Innovación Global",
  description: "Especialistas en soluciones versátiles para movimiento de tierras y agricultura.",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/NEW_HOLLAND.jpg)]",
  idClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center h-48 !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/NEW_HOLLAND.jpg)]"
}, {
  id: "case",
  name: "Case",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_case.png",
  tagline: "Legado Industrial",
  description: "Equipos de construcción diseñados para los desafíos más exigentes del terreno.",
  backgroundImage: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/CASE.jpg",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/CASE.jpg)]"
}, {
  id: "doosan",
  name: "Doosan",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_doosan.png",
  tagline: "Rendimiento Coreano",
  description: "Tecnología de vanguardia en excavadoras y cargadoras de gran capacidad.",
  backgroundImage: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/DOOSAN.jpg",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/DOOSAN.jpg)]"
}, {
  id: "hyundai",
  name: "Hyundai",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/brand_hyundai.png",
  tagline: "Calidad Superior",
  description: "Maquinaria pesada que combina eficiencia de combustible con fuerza bruta.",
  backgroundImage: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/Hyundai-HX210A-L-full-bucket-696x493-1.jpg",
  taglineClassName: "bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center !bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/Hyundai-HX210A-L-full-bucket-696x493-1.jpg)]"
}];
export default function InsuranceCarriers() {
  return <section data-section-id="253259" id="brandshowcase" className="bg-background text-foreground py-20 md:py-32 border-t border-border/50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-3xl">
            
            <h2 className="font-default text-4xl md:text-6xl font-black text-foreground uppercase tracking-tighter leading-none">LA EXPERIeNCIA<br /><span className="text-primary" data-ast-id="f:/src/pages/Home/sections/InsuranceCarriers.tsx|sig:p8yc2l" data-ast-start="4744" data-ast-end="4905">PRIMERO</span></h2>
            <p className="text-muted-foreground mt-6 font-sans text-lg md:text-xl leading-relaxed border-l-2 border-primary pl-6">En un sector tan especializado y competitivo, dedicamos nuestros recursos humanos y técnicos a cubrir las necesidades de recambios solo para marcas de maquinaria de primer nivel y en las que tenemos muchos años de experiencia.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {brandSlots.map((brand, i) => <Card key={brand.id} data-index={i} data-slot={i} className="bg-card border-border/50 hover:border-primary/50 transition-colors duration-300 rounded-lg overflow-hidden flex flex-col h-full">
              <div data-index={i} data-slot={i} className={`${brand.idClassName || ""} ${brand.taglineClassName || ""} bg-secondary/80 p-0 flex items-center justify-center relative group overflow-hidden bg-cover bg-no-repeat bg-center h-48`}>
                
                
              </div>
              
              <CardHeader className="flex-1">
                <CardTitle className="text-xl font-black uppercase tracking-tight text-primary">
                  {brand.name}
                </CardTitle>
                
              </CardHeader>

              
            </Card>)}
        </div>
        
        <div className="mt-12 flex items-center gap-4 text-muted-foreground/50">
          <div className="h-px flex-1 bg-border" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] !text-[rgba(249,116,21,1)]">Calidad CONTRASTADA</span>
          <div className="h-px flex-1 bg-border" />
        </div>
      </div>
    </section>;
}